import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  useDisclosure,
  HStack,
  Text,
} from "@chakra-ui/react";
import { DateTime } from "luxon";
import ExpertDataService from "../../services/Expert";

const AddProgrammeModal = ({ isOpen, onClose, id, func }: any) => {
  const [formData, setFormData] = useState({
    date: "",
    time: "",
    status: "",
    no_of_attendee: "",
    program_id: "",
    image_url: "",
    modified_status: ""
  });

  const [error, setError] = useState("");

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    if (formData.status === "CANCELLED" && !formData.modified_status) {
      setError("Please select a modified status if the program is cancelled.");
      return;
    }


    if (formData.status !== "CANCELLED") {
      formData.modified_status = formData.status;
    }

    const formattedDate = DateTime.fromFormat(
      formData.date,
      "yyyy-MM-dd"
    ).toFormat("MM/dd/yyyy");
    const formattedTime = DateTime.fromFormat(formData.time, "HH:mm").toFormat(
      "hh:mm a"
    );

    const formattedData = {
      ...formData,
      date: formattedDate,
      time: formattedTime,
    };

    ExpertDataService.addProgramme(id, formattedData).then((res) => {
      func();
    });

    onClose();
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Enter Details</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <HStack spacing={4} mb={4}>
              <FormControl>
                <FormLabel>Date</FormLabel>
                <Input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl>
                <FormLabel>Time</FormLabel>
                <Input
                  type="time"
                  name="time"
                  value={formData.time}
                  onChange={handleChange}
                />
              </FormControl>
            </HStack>

            <FormControl mb={4}>
              <FormLabel>Status</FormLabel>
              <Select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="">Select Status</option>
                <option value="COMPLETED">Completed</option>
                <option value="CANCELLED">Cancelled</option>
                <option value="RESCHEDULED">Rescheduled</option>
                {/* <option value="HOLIDAY">Holiday</option> */}
              </Select>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>No. of Attendees</FormLabel>
              <Input
                type="number"
                name="no_of_attendee"
                value={formData.no_of_attendee}
                onChange={handleChange}
              />
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Image URL</FormLabel>
              <Input
                type="url"
                name="image_url"
                value={formData.image_url}
                onChange={handleChange}
              />
            </FormControl>

            {formData.status === "CANCELLED" && (
              <FormControl mb={4}>
                <FormLabel>Modified Status</FormLabel>
                <Select
                  name="modified_status"
                  value={formData.modified_status}
                  onChange={handleChange}
                >
                  <option value="">Select Modified Status</option>
                  <option value="CANCELLED_BY_SPOC">Cancelled by SPOC</option>
                  <option value="CANCELLED_BY_EXPERT">Cancelled by Expert</option>
                  <option value="HOLIDAY">Holiday</option>
                </Select>
              </FormControl>
            )}
            {error && <Text color="red.500">{error}</Text>}
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
              Save
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default AddProgrammeModal;
